export default {
    title: `<i class="fa fa-lg fa-pencil-square"></i> Github Markdown Too Much Infomations`,
    datas: [
        { type: "text",
            content: "Github의 md 파일에서 사용가능한 추가 html에 관해 조금 더 알아보는 파트입니다."
        },
        
        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 키보드(kbd) 태그`
        },
        { type: "code2", code: "md", drag: true,
            content: `<kbd>내용</kbd>`
        },
        { type: "text",
            content: "키보드 입력을 표시하는 kbd 태그를 Github의 md파일에서 사용할 수 있습니다."
        },
        { type: "code", code: "plaintext", drag: true,
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section07/exam01.md",
            content: `크롬 브라우저의 **가장 최근에 닫은 탭을 다시 여는** 단축키는 <kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>t</kbd> 입니다.`
        },


        
        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 아랫첨자와 윗첨자`
        },
        { type: "code2", code: "md", drag: true,
            content:
`<sub>아랫첨자</sub>
<sup>윗첨자</sup>`
        },
        { type: "text",
            content: "HTML의 아랫첨자와 윗첨자 태그인 sub, sup 태그를 적용할 수도 있습니다."
        },
        { type: "code", code: "plaintext", drag: true,
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section07/exam02.md",
            content: `글자에 <sub>아랫첨자</sub>와 <sup>윗첨자</sup>를 사용할 수 있습니다.`
        },


        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 이미지 정렬에 관해`
        },
        { type: "code2", code: "md", drag: true,
            content:
`<img src="이미지경로" align="left">
<img src="이미지경로" align="right">`
        },
        { type: "text",
            content: "이미지를 태그로 사용할때 글자와 겹치지 않도록 aling 속성을 사용하여 좌측, 우측 정렬을 사용할 수 있습니다."
        },
        { type: "code", code: "plaintext", drag: true,
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section07/exam03.md",
            content:            
`<img src="https://codelabs-markdown.web.app/img/md_logo.png" align="right">

### 훈민정음

나랏말싸미 듕귁에 달아 문자와로 서르 사맛디 아니할쎄
이런 젼차로 어린 백셩이 니르고져 홀 배 이셔도
마참내 제 뜨들 시러펴디 몯 할 노미 하니라
내 이랄 위하야 어엿비 너겨 새로 스믈 여듧 짜랄 맹가노니
사람마다 해여 수비 니겨 날로 쑤메 뼌한킈 하고져 할따라미니라

---

<img src="https://codelabs-markdown.web.app/img/md_logo.png" align="left">

### 훈민정음

나랏말싸미 듕귁에 달아 문자와로 서르 사맛디 아니할쎄
이런 젼차로 어린 백셩이 니르고져 홀 배 이셔도
마참내 제 뜨들 시러펴디 몯 할 노미 하니라
내 이랄 위하야 어엿비 너겨 새로 스믈 여듧 짜랄 맹가노니
사람마다 해여 수비 니겨 날로 쑤메 뼌한킈 하고져 할따라미니라`
        },


        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 표(Table) 태그로 만들기`
        },
        { type: "code2", code: "md", drag: true,
            content:
`<table>
    <tr>
        <th>제목셀1</th>
        <th>제목셀2</th>
        <th>제목셀3</th>
    </tr>
    <tr>
        <td>셀1-1</td>
        <td>셀1-2</td>
        <td>셀1-3</td>
    </tr>
    <tr>
        <td>셀2-1</td>
        <td>셀2-2</td>
        <td>셀2-3</td>
    </tr>
</table>`
        },
        { type: "text",
            content: "표에 관한 문법이 있지만 HTML의 table, tr, th, td 태그를 적용할 수도 있습니다. "
                + "(<small>개인적으로 표는 table 태그로 만드는 것이 더 선어호합니다.</small>) "
                + "표를 태그로 그릴시 colspan, rowspan 속성을 활용하면 셀을 합칠 수 있습니다."
        },
        { type: "code", code: "plaintext", drag: true,
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section07/exam04.md",
            content:
`<table>
    <tr>
        <th>제목셀1</th>
        <th>제목셀2</th>
        <th>제목셀3</th>
    </tr>
    <tr>
        <td rowspan="2">세로 합치기</td>
        <td colspan="2">가로 합치기</td>
        <!--<td>가로 합쳐짐</td>-->
    </tr>
    <tr>
        <!--<td>세로 합쳐짐</td>-->
        <td>셀</td>
        <td>셀</td>
    </tr>
</table>`
        },


        { type: "next",
            content: "다음",
            url: "/sections/08"
        },
    ]
}